import { ActionReducer, createFeatureSelector, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import { IArchiveOrder } from '../models/order.models';
import { HybrisOrdersActions } from '../actions';

export interface HybrisOrdersState {
  hybrisOrders: IArchiveOrder[] | null
}

export const initialState: HybrisOrdersState = {
  hybrisOrders: null
};

export const hybrisOrdersBaseState: MemoizedSelector<object, HybrisOrdersState> = createFeatureSelector<HybrisOrdersState>('hybrisOrders');

export const selectHybrisOrders: MemoizedSelector<object, IArchiveOrder[] | null> = createSelector(
  hybrisOrdersBaseState,
  state => state.hybrisOrders
);

export const selectHybrisOrderById: (id: string) => MemoizedSelector<object, IArchiveOrder | undefined> = (id: string): MemoizedSelector<object, IArchiveOrder | undefined> => createSelector(
  hybrisOrdersBaseState,
  state => state.hybrisOrders?.find(order => order?.id === id)
);

export const HybrisOrdersReducer: ActionReducer<HybrisOrdersState> = createReducer(
  initialState,
  on(HybrisOrdersActions.retrieveHybrisOrdersSuccess, (state: HybrisOrdersState, {hybrisOrders}) => {
    return {
      ...state,
      hybrisOrders: hybrisOrders
    };
  })
);
